import RegistrationForm from '../assets/pages/Register'
import LoginPage from '../assets/pages/Login'
import 'core-js/stable'

window.pages = {
  register: RegistrationForm,
  login: LoginPage
}
